import { render, staticRenderFns } from "./AlertModalTemplate.vue?vue&type=template&id=445ef83e&scoped=true"
import script from "./AlertModalTemplate.vue?vue&type=script&lang=js"
export * from "./AlertModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./AlertModalTemplate.vue?vue&type=style&index=0&id=445ef83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ef83e",
  null
  
)

export default component.exports